import React, { useState, useEffect } from 'react';
import classnames from 'classnames';
import UItem from '../item';

import HealthItem from './healthItem';
import { IProps, IChildrenItem, OptionsItem } from './type';
import { deepCopy } from '../../utils/tools';

/**
 * 传入的数组入参是否符合条件，符合时返回数组的长度
 * @param childrens
 * @returns
 */
const hasChildrens = (children): number => {
  if (Array.isArray(children) && children.length) {
    return children.length;
  }
  return 0;
};

/**
 * 给每个子元素赋值 formFieldIndex 用于记录当前form是数组的第几个
 * @param childrens
 * @returns
 */
const setChildrensIndex = (childrens: IChildrenItem[]) => {
  childrens.forEach((item, index) => {
    item.formFieldIndex = index;
  });
  return childrens;
};

/**
 * 清空每一项的默认值，用于新增时的模板，模板中不能有默认值
 * @param children
 * @returns
 */
const formatInitChildFirst = (children: IChildrenItem) => {
  if (!children || !children.props.options || !Array.isArray(children.props.options)) {
    return {};
  }

  const newOptions: Array<OptionsItem> = [];

  children.props.options.forEach((item) => {
    const copyItem = deepCopy(item);
    if (Array.isArray(copyItem.defaultValue)) {
      copyItem.defaultValue = [];
    } else {
      copyItem.defaultValue = '';
    }
    newOptions.push(copyItem);
  });
  return {
    props: {
      options: newOptions,
      title: children.props.title,
    },
  };
};

const copyPropsChildren = (children: any) => {
  return children.map((item) => {
    return {
      props: item.props,
    };
  });
};

// 表单 radio 有子组件的
function URadioHealth(props: IProps) {
  const {
    prefixCls = 'crm-radio-with-health',
    className,
    onChange,
    _crengine,
    children,
    readonly = false,
    defaultValue,
    ...rest
  } = props;
  const copyChildren = copyPropsChildren(children);

  const isNotEmpty = hasChildrens(copyChildren);
  const formatChildrens = setChildrensIndex(isNotEmpty ? copyChildren : []);
  const initChildrens = formatInitChildFirst(isNotEmpty ? copyChildren[0] : {});

  const [healthChildrens, setChildrens] = useState<IChildrenItem[]>(formatChildrens);
  const [index, setIndex] = useState<number>(isNotEmpty ? copyChildren.length - 1 : 0);

  // 初始化反显默认值，支持 defaultValue反显数组形式
  useEffect(() => {
    const setMountValue = () => {
      if (defaultValue && Array.isArray(defaultValue)) {
        const valueChildrens: Array<any> = [];
        defaultValue.forEach((item, newIndex) => {
          const initTemp = deepCopy({ ...initChildrens, formFieldIndex: newIndex });
          Object.keys(item).forEach((key) => {
            initTemp.props.options.forEach((itemOption) => {
              if (itemOption.dataBind === key) {
                itemOption.defaultValue = item[key];
                itemOption.value = item[key];
                if (readonly) {
                  itemOption.readonly = true;
                }
              }
            });
          });
          valueChildrens.push(initTemp);
        });
        setIndex(defaultValue.length - 1);
        setChildrens(valueChildrens);
      }
    };
    setMountValue();
  }, []);

  // 新增一项
  const onAddBtn = () => {
    const newList = deepCopy(healthChildrens);
    const newIndex = index + 1;
    newList.push(deepCopy({ ...initChildrens, formFieldIndex: newIndex }));

    setChildrens(newList);

    setIndex(newIndex);
  };

  // 删除一项
  const onDeleteBtn = (indexDelete: number) => {
    const newList = deepCopy(healthChildrens);

    newList.splice(indexDelete, 1);

    setChildrens(newList);
  };

  const cls = classnames('radio-health-item', className, prefixCls);

  return (
    <UItem {...rest} className={cls} validateTrigger="onChange">
      <HealthItem
        {...rest}
        readonly={readonly}
        _crengine={_crengine}
        healthChildrens={healthChildrens}
        onAddBtn={onAddBtn}
        onDeleteBtn={onDeleteBtn}
      />
    </UItem>
  );
}

export default URadioHealth;
